import React from "react";
import {
  EXPENSE_CATEGORIES,
  settingsList,
  SETTINGS_DETAILS_LIST,
} from "../../constants";
import objectHasProperties from "../../helpers/Utilities/objectHasProperties";
import QualitificationsSection from "../../stories/Components/DocumentsSettings/QuaitificationsSection";
import ChartOfAccountsSection from "../../stories/Components/FinancialsSettings/ChartOfAccountsSection";
import CSICodesAndMappingSection from "../../stories/Components/FinancialsSettings/CSICodesAndMappingSection";
import DivisionCodesSection from "../../stories/Components/FinancialsSettings/DivisionCodesSection";
import PayrollPeriodsSection from "../../stories/Components/FinancialsSettings/PayrollPeriodsSection";
import RateSheetSection from "../../stories/Components/FinancialsSettings/RateSheetSection";
import TaxesRatesSection from "../../stories/Components/FinancialsSettings/TaxesRatesSection";
import TimesheetPeriodsSection from "../../stories/Components/FinancialsSettings/TimesheetPeriodsSection";
import ManagementAssetTypes from "../../stories/Components/ManagementSettings/ManagementAssetTypes";
import AttributeManagementList from "../../stories/Components/ManagementSettings/AttributesManagementList";
import ManagementContactDisciplines from "../../stories/Components/ManagementSettings/ManagementContactDisciplines";
import ManagementRfiTemplateSection from "../../stories/Components/ManagementSettings/ManagementRfiTemplateSection";
import ManagementSubmittalTemplateSubSection from "../../stories/Components/ManagementSettings/ManagementSubmittalTemplateSubSection";
import ManagementTags from "../../stories/Components/ManagementSettings/ManagementTags";
import ManagementTaskDurationSection from "../../stories/Components/ManagementSettings/ManagementTaskDurationSection";
import ManagementWorkflowTemplateSubSection from "../../stories/Components/ManagementSettings/ManagementWorkflowTemplateSubSection";
import RatePerMile from "../../stories/Components/SettingsAndConfiguration/RatePerMile";
import SelectSection from "../../stories/Components/SettingsAndConfiguration/SelectSection";
import SettingsTable from "../../stories/Components/SettingsAndConfiguration/SettingsTable";
import BenefitsSection from "../../stories/Components/SystemSettings/BenefitsSection";
import HolidaysSection from "../../stories/Components/SystemSettings/HolidaysSection";
import HoursOfOperationSection from "../../stories/Components/SystemSettings/HoursOfOperationSection";
import PreferencesLibrarySection from "../../stories/Components/SystemSettings/PreferencesLibrarySection";
import PtoSection from "../../stories/Components/SystemSettings/PtoSection";
import UnitOfMeasurementSection from "../../stories/Components/SystemSettings/UnitOfMeasurementSection";
import BackButton from "../../stories/Components/WidgetEditorView/Header/BackButton";
import LilySettings from "../../stories/Components/ManagementSettings/LilySettings";
import TableHeader from "./TableHeader";
import ContainerEditButtons from "./ContainerEditButtons";

const {
  ASSET_CATEGORY,
  ATTRIBUTES,
  BENEFITS,
  BUDGET_UNITS_OF_MEASURE,
  CHART_OF_ACCOUNTS,
  CONTACT_DISCIPLINES,
  CSI_CODES_AND_MAPPINGS,
  DIVISION_CODES,
  HOLIDAYS,
  LEVEL_TYPES,
  LILY,
  PAID_TIME_OFF,
  PAYROLL_PERIOD,
  PREFERENCES_LIBRARY,
  PROJECT_TYPES,
  PROJECT_INSPECTION_TYPES,
  PROPERTY_TYPES,
  QUALIFICATIONS_AND_EXCLUSIONS,
  RATE_SHEET,
  SPACE_TYPES,
  SOP_TYPES,
  SUBMITTAL_TEMPLATE,
  SUBMITTAL_TYPES,
  TAGS,
  TAX_RATES,
  RFI_TEMPLATE,
  TASK_DURATION,
  HOURS_OF_OPERATION,
  TIMESHEET_PERIOD,
  WORKFLOW_TEMPLATE,
  WORLD_CLOCK,
  RATE_PER_MILE,
  SERVICE_REQUEST_TYPES,
} = SETTINGS_DETAILS_LIST;

const SettingsAndConfigurationList = ({
  managementSettings,
  dispatchManagementSettings,
  systemSettings,
  dispatchSystemSettings,
  financialsSettings,
  dispatchFinancialsSettings,
  documentsSettings,
  dispatchDocumentsSettings,
  tagsSettings,
  dispatchTagsSettings,
  navigateToHolidaysSection,
  onCancel,
  onSave,
  isSaving,
  isLoading,
  settingDetails,
  setSettingDetails,
  noChangesMade,
  isValid,
  setIsValid,
  resetSystemSettings,
  isPtoLocationInvalid,
}) => {
  /**
   * When updating to match new designs, add onSave & resetSystemSettings & onCancel
   * to props to component screen to handle new edit button and onSave in the specific component
   * Add to list of cases to hide the previous save/cancel, when all are updated we can remove previous.
   */
  const settingsDetailsContent = () => {
    switch (settingDetails.title) {
      case ASSET_CATEGORY.title:
        return (
          <ManagementAssetTypes
            managementSettings={managementSettings}
            dispatchManagementSettings={dispatchManagementSettings}
          />
        );
      case ATTRIBUTES.title:
        return <AttributeManagementList />;
      case BENEFITS.title:
        return (
          <BenefitsSection
            systemSettings={systemSettings}
            dispatchSystemSettings={dispatchSystemSettings}
          />
        );
      case BUDGET_UNITS_OF_MEASURE.title:
        return (
          <UnitOfMeasurementSection
            systemSettings={systemSettings}
            dispatchSystemSettings={dispatchSystemSettings}
          />
        );
      case CHART_OF_ACCOUNTS.title:
        return (
          <ChartOfAccountsSection
            financialsSettings={financialsSettings}
            dispatchFinancialsSettings={dispatchFinancialsSettings}
          />
        );
      case CONTACT_DISCIPLINES.title:
        return (
          <ManagementContactDisciplines
            managementSettings={managementSettings}
            dispatchManagementSettings={dispatchManagementSettings}
          />
        );
      case CSI_CODES_AND_MAPPINGS.title:
        return (
          <CSICodesAndMappingSection
            financialsSettings={financialsSettings}
            dispatchFinancialsSettings={dispatchFinancialsSettings}
          />
        );
      case DIVISION_CODES.title:
        return (
          <DivisionCodesSection
            financialsSettings={financialsSettings}
            dispatchFinancialsSettings={dispatchFinancialsSettings}
          />
        );
      case SETTINGS_DETAILS_LIST.EXPENSE_CATEGORIES.title:
        return (
          <SelectSection
            selection={{
              selectionName: "Category",
              selectionValue: EXPENSE_CATEGORIES,
              selectionItemValue: "display",
            }}
            settings={{
              settings: financialsSettings,
              dispatchSettings: dispatchFinancialsSettings,
            }}
            setIsValid={setIsValid}
          />
        );
      case HOLIDAYS.title:
        return (
          <HolidaysSection
            systemSettings={systemSettings}
            dispatchSystemSettings={dispatchSystemSettings}
          />
        );
      case LEVEL_TYPES.title:
        return (
          <SelectSection
            selection={{
              selectionName: "Level Type",
              selectionValue: "propertyLevelTypes",
              selectionItemValue: "display",
            }}
            settings={{
              settings: managementSettings,
              dispatchSettings: dispatchManagementSettings,
            }}
            setIsValid={setIsValid}
          />
        );
      case LILY.title:
        return (
          <LilySettings
            settings={managementSettings}
            dispatchSettings={dispatchManagementSettings}
          />
        );
      case PAID_TIME_OFF.title:
        return (
          <PtoSection
            systemSettings={systemSettings}
            dispatchSystemSettings={dispatchSystemSettings}
            setIsValid={setIsValid}
          />
        );
      case PAYROLL_PERIOD.title:
        return (
          <PayrollPeriodsSection
            financialsSettings={financialsSettings}
            dispatchFinancialsSettings={dispatchFinancialsSettings}
          />
        );
      case PREFERENCES_LIBRARY.title:
        return (
          <PreferencesLibrarySection
            systemSettings={systemSettings}
            dispatchSystemSettings={dispatchSystemSettings}
          />
        );
      case PROJECT_TYPES.title:
        return (
          <SelectSection
            selection={{
              selectionName: "Project Type",
              selectionValue: "projectTypes",
              selectionItemValue: "display",
            }}
            settings={{
              settings: managementSettings,
              dispatchSettings: dispatchManagementSettings,
            }}
            setIsValid={setIsValid}
          />
        );
      case PROJECT_INSPECTION_TYPES.title:
        return (
          <SelectSection
            selection={{
              selectionName: "Project Inspection Type",
              selectionValue: "projectInspectionTypes",
              selectionItemValue: "display",
            }}
            settings={{
              settings: managementSettings,
              dispatchSettings: dispatchManagementSettings,
            }}
            setIsValid={setIsValid}
          />
        );
      case PROPERTY_TYPES.title:
        return (
          <SelectSection
            selection={{
              selectionName: "Property Type",
              selectionValue: "propertyTypes",
              selectionItemValue: "display",
            }}
            settings={{
              settings: managementSettings,
              dispatchSettings: dispatchManagementSettings,
            }}
            setIsValid={setIsValid}
          />
        );
      case QUALIFICATIONS_AND_EXCLUSIONS.title:
        return (
          <QualitificationsSection
            documentsSettings={documentsSettings}
            dispatchDocumentsSettings={dispatchDocumentsSettings}
          />
        );
      case RATE_SHEET.title:
        return (
          <RateSheetSection
            financialsSettings={financialsSettings}
            dispatchFinancialsSettings={dispatchFinancialsSettings}
            navigateToHolidaysSection={navigateToHolidaysSection}
          />
        );
      case SPACE_TYPES.title:
        return (
          <SelectSection
            selection={{
              selectionName: "Space Type",
              selectionValue: "propertySpaceTypes",
              selectionItemValue: "display",
            }}
            settings={{
              settings: managementSettings,
              dispatchSettings: dispatchManagementSettings,
            }}
            setIsValid={setIsValid}
          />
        );
      case SOP_TYPES.title:
        return (
          <SelectSection
            selection={{
              selectionName: "Type",
              selectionValue: "sopCategories",
              selectionItemValue: "display",
            }}
            settings={{
              settings: systemSettings,
              dispatchSettings: dispatchSystemSettings,
            }}
            setIsValid={setIsValid}
          />
        );
      case SUBMITTAL_TEMPLATE.title:
        return (
          <ManagementSubmittalTemplateSubSection
            managementSettings={managementSettings}
            dispatchManagementSettings={dispatchManagementSettings}
          />
        );
      case SUBMITTAL_TYPES.title:
        return (
          <SelectSection
            selection={{
              selectionName: "Submittal Type",
              selectionValue: "submittalTypes",
              selectionItemValue: "display",
            }}
            settings={{
              settings: managementSettings,
              dispatchSettings: dispatchManagementSettings,
            }}
            setIsValid={setIsValid}
          />
        );
      case TAGS.title:
        return (
          <ManagementTags
            tagsSettings={tagsSettings}
            dispatchTagsSettings={dispatchTagsSettings}
          />
        );
      case TAX_RATES.title:
        return (
          <TaxesRatesSection
            financialsSettings={financialsSettings}
            dispatchFinancialsSettings={dispatchFinancialsSettings}
          />
        );
      case RFI_TEMPLATE.title:
        return (
          <ManagementRfiTemplateSection
            managementSettings={managementSettings}
            dispatchManagementSettings={dispatchManagementSettings}
          />
        );
      case TASK_DURATION.title:
        return (
          <ManagementTaskDurationSection
            managementSettings={managementSettings}
            dispatchManagementSettings={dispatchManagementSettings}
          />
        );
      // case "RFP Template":
      //   return (
      //   );
      case HOURS_OF_OPERATION.title:
        return (
          <HoursOfOperationSection
            systemSettings={systemSettings}
            dispatchSystemSettings={dispatchSystemSettings}
          />
        );
      // case "Submission Requirements for RFP":
      //   return (
      //   );
      case TIMESHEET_PERIOD.title:
        return (
          <TimesheetPeriodsSection
            financialsSettings={financialsSettings}
            dispatchFinancialsSettings={dispatchFinancialsSettings}
          />
        );
      case WORKFLOW_TEMPLATE.title:
        return (
          <ManagementWorkflowTemplateSubSection
            managementSettings={managementSettings}
            dispatchManagementSettings={dispatchManagementSettings}
          />
        );
      case WORLD_CLOCK.title:
        return (
          <SelectSection
            selection={{
              selectionName: "World Clock Zone",
              selectionValue: "cities",
              selectionItemValue: "city",
              selectionSecondItemValue: "cityCode",
            }}
            settings={{
              settings: systemSettings,
              dispatchSettings: dispatchSystemSettings,
            }}
            setIsValid={setIsValid}
          />
        );
      case RATE_PER_MILE.title:
        return (
          <RatePerMile
            financialsSettings={financialsSettings}
            dispatchFinancialsSettings={dispatchFinancialsSettings}
          />
        );
      case SERVICE_REQUEST_TYPES.title:
        return (
          <SelectSection
            selection={{
              selectionName: "Service Request Type",
              selectionValue: "ticket",
              selectionItemValue: "display",
            }}
            settings={{
              settings: managementSettings,
              dispatchSettings: dispatchManagementSettings,
            }}
            setIsValid={setIsValid}
          />
        );
      default:
        return null;
    }
  };

  const onClick = (item) => {
    setSettingDetails(item);
  };

  // Add other screens that need to disable old save/cancel buttons
  const disableButtons = settingDetails?.title === "Attributes";

  return objectHasProperties(settingDetails) ? (
    <div className="flex flex-col gap-4 justify-start">
      <div className="flex flex-row justify-between w-full items-start">
        <BackButton
          buttonClassName="flex w-fit"
          onBackPressed={() =>
            setSettingDetails(settingDetails.customBackNavigation ?? {})
          }
        />
        <ContainerEditButtons
          onSave={onSave}
          isValid={isValid}
          isSaving={isSaving}
          onCancel={onCancel}
          isLoading={isLoading}
          noChangesMade={noChangesMade}
          isPtoLocationInvalid={isPtoLocationInvalid}
          disableButtons={disableButtons}
          resetSystemSettings={resetSystemSettings}
        />
      </div>
      <TableHeader settingDetails={settingDetails} />
      {settingsDetailsContent()}
    </div>
  ) : (
    <SettingsTable data={settingsList} onClick={onClick} />
  );
};

export default SettingsAndConfigurationList;
